import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

// Inner page hero: dark navy with image, breadcrumb, title + subtitle.
export const PageHero = ({ overline, title, subtitle, image, crumb }) => {
  return (
    <section className="relative min-h-[62vh] flex items-end overflow-hidden bg-[#0F172A]" data-testid="page-hero">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="w-full h-full object-cover opacity-40" loading="eager" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A] via-[#0F172A]/70 to-[#0F172A]/50" />
        </div>
      )}
      <div className="absolute inset-0 bg-grid-dark opacity-30" />
      <div className="relative w-full max-w-[1320px] mx-auto px-5 sm:px-8 pb-16 pt-40">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <nav className="flex items-center gap-2 text-sm text-slate-400 mb-6">
            <Link to="/" className="hover:text-white transition-colors">Home</Link>
            <ChevronRight className="w-3.5 h-3.5" />
            <span className="text-white">{crumb || title}</span>
          </nav>
          {overline && (
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-8 bg-blue-300" />
              <span className="text-xs font-semibold tracking-[0.25em] uppercase text-blue-200">{overline}</span>
            </div>
          )}
          <h1 className="font-display font-bold text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-4xl">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 text-lg sm:text-xl text-slate-300 max-w-2xl leading-relaxed">{subtitle}</p>
          )}
        </motion.div>
      </div>
    </section>
  );
};
